<div class="login-container">
  <mobi-office-lib-log-in-page [isBannerLogoVisible]="true" [isForgetPassword]="true" [isCardLogoVisible]="false" (signInEmitter)="onSignIn($event)"></mobi-office-lib-log-in-page>
</div>
